import React, { useState, useEffect } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Badge } from "../../../components/Elements/TextStyles/Badge";
import { Button, Checkbox } from "antd";

const SupportFilter = ({ onOpen, onClose, setStatus, selectedStatus }) => {
  const [checkedItems, setCheckedItems] = useState({
    inProcess: false,
    Open: false,
    Closed: false,
  });

  // Sync child state when parent updates
  useEffect(() => {
    setCheckedItems({
      inProcess: selectedStatus.includes("inProcess"),
      Open: selectedStatus.includes("Open"),
      Closed: selectedStatus.includes("Closed"),
    });
  }, [selectedStatus]);

  const handleCheckboxChange = (e) => {
    setCheckedItems({ ...checkedItems, [e.target.name]: e.target.checked });
  };

  const handleSave = () => {
    const selectedStatuses = Object.keys(checkedItems).filter(
      (key) => checkedItems[key]
    );

    setStatus(selectedStatuses);
    onClose(); // Close dialog after saving
  };

  const handleCancel = () => {
    setCheckedItems({ inProcess: false, Open: false, Closed: false }); // Uncheck all
    onClose(); // Close dialog
  };

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
      <div>
        <h3 className="text-xl">Filter</h3>
      </div>
      <div
        style={{
          border: "1px solid #ebedf3",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <div className="flex-col">
          <div className="flex justify-between my-4 mx-10">
            <div className="flex justify-center">
              {" "}
              <Badge text="In-Process" />{" "}
            </div>
            <Checkbox
              name="inProcess"
              checked={checkedItems.inProcess}
              onChange={handleCheckboxChange}
            />
          </div>
          <hr className="mx-8" />
          <div className="flex justify-between my-4 mx-10">
            <div className="flex justify-center">
              {" "}
              <Badge text="Open" />
            </div>
            <Checkbox
              name="Open"
              checked={checkedItems.Open}
              onChange={handleCheckboxChange}
            />
          </div>
          <hr className="mx-8" />
          <div className="flex justify-between my-4 mx-10">
            <div className="flex justify-center">
              {" "}
              <Badge text="Closed" />{" "}
            </div>
            <Checkbox
              name="Closed"
              checked={checkedItems.Closed}
              onChange={handleCheckboxChange}
            />
          </div>
          <hr className="mx-8" />
        </div>
        <div className="flex justify-center px-20 gap-10 my-10">
          <Button
            style={{
              background: "#e7fefe",
              height: "40px",
              width: "150px",
              borderRadius: "10px",
              border: "1px solid #06513D",
            }}
            className="text-base font-normal text-[#06513D] bg-[#E6EDEB] hover:!bg-[#F8F8F8] hover:!text-[#06513D]"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            style={{
              background: "#06513D",
              height: "40px",
              width: "150px",
              borderRadius: "10px",
            }}
            className="text-base font-normal bg-[#06513D] hover:!bg-[#387464]"
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </div>
    </DailogBox>
  );
};

export default SupportFilter;
